var map = {
	"./NAAAPTampa.jpg": 23,
	"./amazon.jpg": 24,
	"./default.svg": 64,
	"./lostwind.jpg": 25,
	"./nielsen.jpg": 26,
	"./sciencefiction.jpg": 27,
	"./tampa.jpg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;